class MFRVarietyBundle {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      carousel: ".product-top__images-carousel",
      carouselThumbnails: ".product-top__thumbs-carousel",
      quantitySelector: ".custom-quantity-selector-container",
      quantityInput: "input[name='quantity']",
      containers: ".custom-quantity-product-container",
      product: ".custom-quantity-product",
      singleItem: ".custom-quantity-product__item",
      productInput: ".custom-quantity-product label input",
      productList: ".custom-quantity-product-inner",
      timer: ".product-top__timer",
      qtyAddMinusButtons: ".quantity-selector-button",
      subscriptionSelector: ".subscription-selector",
      subscriptionPrice: ".subscription-selector .with-old-price",
      oneTimePrice: ".one-time-selector .subscription-selector__selector-price",
      addToBundle: ".add-to-bundle",
      addToCart: ".add-to-cart",
      readMoreBtn: ".toggle-text"
    };

    this.cartCurrency = {
      money_format: `${window.currencyVariables.symbol}{{amount}}`
    }

    this.init();
  }

  init() {
    this.$carousel = this.$element.find(this.selectors.carousel);
    this.$carouselThumbnails = this.$element.find(this.selectors.carouselThumbnails);
    this.$containers = this.$element.find(this.selectors.containers);
    this.$quantitySelector = this.$element.find(this.selectors.quantitySelector);
    this.$product = this.$element.find(this.selectors.product);
    this.$productInput = this.$element.find(this.selectors.productInput);
    this.$productList = this.$element.find(this.selectors.productList);
    this.$addToCart = this.$element.find(this.selectors.addToCart);
    this.$addToBundle = this.$element.find(this.selectors.addToBundle);
    this.$qtyAddMinusButtons = this.$element.find(this.selectors.qtyAddMinusButtons);
    this.$subscriptionSelector = this.$element.find(this.selectors.subscriptionSelector);
    this.$singleItem = this.$element.find(this.selectors.singleItem);
    this.$readMoreBtn = this.$element.find(this.selectors.readMoreBtn);
    this.$timer = this.$element.find(this.selectors.timer);
    this.$subscriptionPrice = this.$element.find(this.selectors.subscriptionPrice);
    this.$oneTimePrice = this.$element.find(this.selectors.oneTimePrice);

    this.$quantitySelector.find("input").on("change", this.__handleQuantityClick.bind(this));
    this.$productInput.on("change", this.__handleProductClick.bind(this));
    this.$productList.on("click", this.__handleProductListClick.bind(this));
    this.$qtyAddMinusButtons.on("click", this.__handleAddMinusQuantity.bind(this));
    this.$subscriptionSelector.find("input[name=purchase_selector]").on("change", this.__handleSubscriptionChange.bind(this));
    this.$addToBundle.on("click", this.__handleAddToBundle.bind(this));
    this.$addToCart.on("click", this.addToCart.bind(this));
    this.$readMoreBtn.on("click", this.toggleDescription.bind(this));
    this.$flag = true;

    this.initState();
    this.setCountDown();
    this.setInitialPrices();
    this.changeBundleState();
    this.initCarousel();
    this.__handleProductListOutsideClick();

    setTimeout(() => {
      this.setMinHeightLists();
      this.$carousel.flickity('resize');
      this.$carouselThumbnails.flickity('resize');
    }, 2000)
  }

  initState() {
    const products = window.products.split("|");
    this.$products = [];

    for(let i = 0; i < products.length; i++) {
      const product = products[i].split("::");

      this.$products.push({
        id: product[0],
        name: product[1],
        description: product[2]
      })
    }

    const selectedQuantity = this.$element.find(".custom-quantity-selector-container.selected");
    this.$selectedQuantity = $(selectedQuantity).data("quantity");
    this.$selectedDiscount = this.getDiscount(selectedQuantity);
    // this.setQuantityPrice();
    this.updateIndicator();
    this.setSubscriptionPrice();

    this.setSingleItemsQtyTracker(5)
  }

  initCarousel() {
    this.$carousel.flickity({
      pageDots: false,
      prevNextButtons: true
    });

    this.__handleSlideChange();
    this.initCarouselThumbnails();
  }

  initCarouselThumbnails() {
    const $element = this.$element;
    const $mainCarousel = this.$carousel;
    const $productList = this.$products;

    this.$carouselThumbnails.flickity({
      sync: '.product-top__images-carousel',
      pageDots: false,
      prevNextButtons: false,
      groupCells: 1,
      align: 'left',
      contain: true
    });

    this.$carouselThumbnails.find('.product-top__image').each(function(index) {
      $(this).on("click", function() {
        $mainCarousel.flickity('select', index);

        const $selectedSlide = $(this).data("id");
        const product = $productList.find(a => a.id == $selectedSlide);

        if (product.length == 0) return;

        const newTitle = product.name;
        const newDescription = product.description;

        $element.find('.section-title__inner').text(newTitle);
        $element.find('.product-top__description').html(newDescription);
      })
    })
  }

  getQuantity() {
    // Applies only to single item
    if(this.$singleItem.length == 0) return 0;
    let quantity = 0;

    this.$singleItem.each((index, item) => {
      const input = $(item).find("input[type=number]");
      quantity += parseInt($(input).val());
    });

    return quantity;
  }

  getDiscount(element) {
    const discountAttr = $(element).data("discount") ||  0;
    let discount = discountAttr;

    if(discountAttr !== 0) {
      discount = parseInt(discountAttr?.replace("%", ""))
    }

    return discount;
  }

  __handleQuantityClick(e) {
    // Applies to both templates: accordion and single type
    const target = e.currentTarget;
    const input = $(target);
    const parent = $(target).closest(this.selectors.quantitySelector);
    const quantity = $(target).val();

    this.$element.find(`${this.selectors.quantitySelector}.selected`).removeClass("selected");

    if($(input)[0].checked) {
      $(parent).addClass("selected");
    }

    this.$selectedQuantity = quantity;
    this.$selectedDiscount = this.getDiscount(parent);

    this.calculateTotalPrice();
    this.resetSingleItemSelection();
    this.changeATCState();
    this.changeBundleState();

    this.setSingleItemsQtyTracker(quantity)
  }

  __handleProductClick(e) {
    // Only applies to accordion type selector
    const target = e.currentTarget;
    const input = $(target);
    const parent = $(target).closest(this.selectors.product);
    const parentList = $(target).closest(this.selectors.productList);
    const selected = $(parentList).find(`${this.selectors.product}.selected`);
    const quantitySelectorParent = $(target).closest(this.selectors.quantitySelector);

    $(selected).removeClass("selected");

    if($(input)[0].checked) {
      $(parent).addClass("selected");
    }

    $(parentList).removeClass("selected");

    this.setQuantitySelectorPrices(quantitySelectorParent);
    this.calculateTotalPrice();
    this.getBundleItems();
  }

  __handleProductListClick(e) {
    const target = e.currentTarget;
    const child = this.selectors.product.replace(".", "");
    const selected = $(`${this.selectors.productList}.selected`);

    if(!this.$flag) {
      this.$flag = true;
      return;
    }

    if($(target).hasClass("selected") && ($(e.target).closest(`.${child}.selected`) || $(e.target).hasClass(`.selected`))) {
      $(target).removeClass("selected");
      this.$flag = false;
      return;
    }

    if ($(selected) != $(target)) {
      $(selected)?.removeClass("selected");
    }

    if ($(e.target).hasClass(child) || $(e.target).closest(`.${child}`).length > 0) {
      const parent = $(e.target).hasClass(child) ? $(e.target) : $(e.target).closest(`.${child}`);
      const input = $(parent).find("input");

      if ($(input)[0].checked) {
        $(target).addClass("selected");
      }
      // else {
      //   $(target).removeClass("selected");
      // }
    } else {
      $(target).toggleClass("selected");
    }

    this.$flag = false;
  }

  __handleProductListOutsideClick() {
    $(document).on('click', function(event) {
      if ($(event.target).closest('.custom-quantity-product-inner').length === 0) {
        $('.custom-quantity-product-inner.selected').removeClass('selected')
      }
    })
  }

  __handleAddMinusQuantity(e) {
    // Only applies to single item selection template
    const target = e.currentTarget;
    const parent = $(target).closest(this.selectors.singleItem);
    const input = $(parent).find("input[type='number']");
    const quantityText = $(parent).find(".quantity");
    let currentQuantity = $(input).val();

    if($(target).hasClass("add")) {
      if(this.$totalQuantity >= this.$selectedQuantity) return;
      currentQuantity++;
      $(input).val(currentQuantity);
      $(quantityText).text(currentQuantity);
    } else {
      if(currentQuantity <= 0) return;
      currentQuantity--;
      $(input).val(currentQuantity);
      $(quantityText).text(currentQuantity);
    }

    if($(input).val() == 0) {
      $(parent).removeClass("selected")
    } else {
      $(parent).addClass("selected")
    }

    this.changeBundleState();
  }

  __handleSlideChange() {
    if(window.layout != "single-item") return;

    this.$carousel.on('change.flickity', (event, index) => {
      const $selectedSlide = this.$carousel.find('.product-top__image').eq(index).data("id");

      const product = this.$products.find(a => a.id ==  $selectedSlide);
      if(product.length == 0) return;

      const newTitle = product.name;
      const newDescription = product.description;

      this.$element.find('.section-title__inner').text(newTitle);
      this.$element.find('.product-top__description').html(newDescription);
      this.$readMoreBtn.removeClass("visually-hidden");
    });
  }

  __handleSubscriptionChange(e) {
    if(window.layout != "single-item") return;

    const target = e.currentTarget;
    const parent = $(target).closest("label");
    const subscription = $(parent).find("input").val();

    if (subscription == "subscription") {
      this.$product.each((index, item) => {
        if($(item).data("subscription")) {
          $(item).show();
        } else {
          $(item).hide();
        }
      });

      $("#total-price-original").show();
    } else {
      this.$product.each((index, item) => {
        $(item).show();
      });

      $("#total-price-original").hide();
    }

    this.$element.find(`${this.selectors.subscriptionSelector} label.selected`).removeClass("selected");
    $(parent).addClass("selected");

    // this.resetSingleItemSelection();
    this.changeBundleState();
  }

  setSingleItemsQtyTracker(quantity) {
    const selectedItemsContainer = $(".single-items-selected-products")

    if (selectedItemsContainer.length == 0) return

    selectedItemsContainer.html("")

    for (var i = 0; i < quantity; i++) {
      selectedItemsContainer.append('<div class="selected-single-item"></div>')
    }
  }

  populateSingleItemsQtyTracker(array) {
    const selectedItemsContainer = $(".single-items-selected-products")
    if (selectedItemsContainer.length === 0) return

    let divIndex = 0

    selectedItemsContainer.children().each(function() {
      $(this).empty()
    })

    if(array.length === 0) return;

    array.forEach(function(item) {
      let imgSrc = item.imageSrc
      let qty = parseInt(item.quantity)

      for (let i = 0; i < qty; i++) {
        let $targetDiv = selectedItemsContainer.children().eq(divIndex)
        if ($targetDiv.length) {
          $targetDiv.append('<img src="' + imgSrc + '">')
          divIndex++
        }
      }
    })
  }

  // populateFlavorsIngredientsModalContent(array) {
  //   const flavorsIngredientsModalContainer = $("#flavors-ingredients-content")

  //   if (flavorsIngredientsModalContainer.length === 0) return

  //   flavorsIngredientsModalContainer.empty()

  //   if(array.length === 0) return;

  //   let contentHTML = ""

  //   array.forEach(function(item) {
  //     let title = item.title,
  //         image = item.imageSrc,
  //         ingredients = item.ingredients,
  //         description = item.description

  //     contentHTML += `
  //       <div class="flavor-ingredient-item">
  //         <div class="image">
  //           <img src="${image}" alt="${title} - ${description}" class="image-contain" />
  //         </div>
  //         <div class="content">
  //           <h5>${title}</h5>
  //           <p>${description}</p>
  //           <p><strong>Toppings:</strong> ${ingredients}</p>
  //         </div>
  //       </div>
  //     `
  //   })

  //   flavorsIngredientsModalContainer.html(contentHTML)
  // }

  getSingleItemTotal() {
    let total = 0;
    const quantityDiscount = 1 - parseFloat(this.$selectedDiscount / 100);

    this.$singleItem.each((index, item) => {
      const input = $(item).find("input[type=number]");
      const quantity = $(input).val();
      const price = $(input).data("price");

      total += quantity * parseInt(price) * quantityDiscount;
    });

    return total;
  }

  getExcessTotal(total) {
    // Shopify Computation
    const decimal = total % 1;

    if(decimal < 0.5 && decimal > 0) {
      const value = total + 1;
      return value / 100;
    } else if(decimal >= 0.5) {
      return Math.round(total / 100)
    }

    return (total / 100);
  }

  getSingleItemTotalDiscounted() {
    const quantityDiscount = 1 - parseFloat(this.$selectedDiscount / 100);
    const subscriptionDiscount = 1 - parseFloat($("input[name=purchase_selector][value=subscription]").data("price-discount") || 0);
    let total = 0;

    this.$singleItem.each((index, item) => {
      const input = $(item).find("input[type=number]");
      const quantity = $(input).val();
      const price = $(input).data("price");
      const originalPrice = parseInt(price) * quantityDiscount * subscriptionDiscount;
      const discounted = this.getExcessTotal(originalPrice);

      total += parseFloat(discounted.toFixed(2)) * quantity;
    });

    return Math.floor(total * 100);
  }

  setSubscriptionPrice() {
    if(window.layout != "single-item") return;

    const total = this.getSingleItemTotal();

    const oneTimeTotal = window.Shopify.formatMoney(total, this.cartCurrency.money_format)
    this.$oneTimePrice.text(oneTimeTotal);

    let subscriptionTotal = this.getSingleItemTotalDiscounted();
    subscriptionTotal = window.Shopify.formatMoney(subscriptionTotal, this.cartCurrency.money_format)

    this.$subscriptionPrice.text(subscriptionTotal);
    this.$subscriptionPrice.attr("data-base-price", oneTimeTotal);

    if(total == 0) {
      this.$subscriptionPrice.removeAttr("data-base-price");
    }
  }

  // setQuantityPrice() {
  //   if(window.layout != "single-item") return;
  //   const total = this.getSingleItemTotal();

  //   this.$quantitySelector.each((index, item) => {
  //     let discount = this.getDiscount(item) / 100;
  //     discount = total * (discount || 0);
  //     const price = total - discount;

  //     $(item).find(".price").text(window.Shopify.formatMoney(price));
  //   });
  // }

  changeATCState() {
    if(window.layout != "single-item") return;

    if(this.$totalQuantity == this.$selectedQuantity) {
      this.$addToCart.removeAttr("disabled");
    } else {
      this.$addToCart.attr("disabled", true);
    }
  }

  changeBundleState() {
    this.$totalQuantity = this.getQuantity();
    this.getBundleItems();
    this.setSubscriptionPrice();
    this.calculateTotalPrice();
    this.changeATCState();
    this.updateIndicator();
    // this.setQuantityPrice();
  }

  computeTotal(parent, isNewPrice) {
    if(parent.length == 0) return;
    let discount = this.getDiscount(parent);
    discount = parseFloat(discount) / 100;
    let total = 0;

    if(window.layout == "single-item") {
      const selectedSubscription = $("input[name=purchase_selector]:checked").data("price-discount") || 0;
      if(selectedSubscription > 0) {
        total = this.getSingleItemTotalDiscounted();
      } else {
        total = this.getSingleItemTotal();
      }
    } else {
      const selectedProducts = $(parent).find("input.product:checked");

      $(selectedProducts).each((index, item) => {
        let price = parseFloat($(item).data("price"));
        total += price;
      });

      if (isNewPrice) {
        total = total - (total * discount);
      }
    }

    total = window.Shopify.formatMoney(total, this.cartCurrency.money_format)

    return total;
  }

  setQuantitySelectorPrices(item) {
    // For accordion quantity selector
    const parent = $(item).closest("label");
    const oldPrice = $(item).find(".custom-quantity-price .old-price");
    const price = $(item).find(".custom-quantity-price .price");

    const oldTotal = this.computeTotal(parent, false);
    const newTotal = this.computeTotal(parent, true);

    $(price).text(newTotal);
    if(oldPrice) $(oldPrice).text(oldTotal);
  }

  setMinHeightLists() {
    this.$containers.each((index,item) => {
      $(item).css("min-height", `${$(item).height() + 10}px`);
    });
  }

  setInitialPrices() {
    this.$quantitySelector.each((index, item) => {
      this.setQuantitySelectorPrices(item);
    })
  }

  updateIndicator() {
    const indicator = this.$element.find(".custom-quantity-product__indicator");
    if($(indicator).length == 0) return;
    const quantityLeft = this.$selectedQuantity - this.$totalQuantity;

    $(indicator).text(`${quantityLeft} Flavors to go`);
  }

  calculateTotalPrice() {
    let total = 0;
    let quantityParent;
    let originalTotalPrice;

    if(window.layout == "single-item") {
      quantityParent = this.$element.find(".custom-quantity-selector-container.selected");

      originalTotalPrice = $(".one-time-selector").find('.subscription-selector__selector-price')
    } else {
      const selectedQuantity = $("input[name='quantity']:checked")[0];
      quantityParent = $(selectedQuantity).closest("label")[0];

      originalTotalPrice = $(quantityParent).find('.custom-quantity-price .old-price')
    }

    total = this.computeTotal(quantityParent, true);
    $("#total-price").html(` &mdash; ${total}`);

    if (originalTotalPrice.length > 0) {
      $("#total-price-original").html(originalTotalPrice.html())
    } else {
      $("#total-price-original").html("")
    }
  }

  generateTimeBasedHashId(prefix) {
    const timestamp = Date.now().toString(36); // base-36 timestamp
    const random = Math.random().toString(36).substr(2, 5); // random string
    return `${prefix}_${timestamp}_${random}`;
  }

  getBundleItems() {
    const array = [];
    const bundle_hash = this.generateTimeBasedHashId("bundle");
    let properties = {};

    if (this.$selectedQuantity > 1) {
      properties = { _bundle_hash: bundle_hash, _bundle_discount: this.$selectedDiscount, type: "Bundle Pack" }
    }

    if (window.layout == "single-item") {
      if(this.$singleItem.length == 0) return 0;

      this.$singleItem.each((index, item) => {
        const input = $(item).find("input[type=number]");
        const isSubscription = this.$element.find(`${this.selectors.subscriptionSelector} [name=purchase_selector]:checked`).val();
        const quantity = $(input).val();
        const imageSource = $(item).data("img")
        const shorTitle = $(item).data("title")
        const shortDescription = $(item).data("description")
        const ingredientsList = $(item).data("ingredients")

        if (quantity > 0) {
          const product = $(input).data("id");

          if (isSubscription == "subscription") {
            const subscription = this.$element.find(`${this.selectors.subscriptionSelector} [name=selling_plan]:checked`).val();
            array.push({ id: product, quantity: quantity, selling_plan: subscription, properties: properties, imageSrc: imageSource, title: shorTitle, ingredients: ingredientsList, description: shortDescription });
          } else {
            array.push({ id: product, quantity: quantity, properties: properties, imageSrc: imageSource, title: shorTitle, ingredients: ingredientsList, description: shortDescription });
          }
        }
      });
    } else {
      const selectedQuantity = this.$element.find(`${this.selectors.quantitySelector}.selected`)
      const selectedProducts = $(selectedQuantity).find("input.product:checked");

      $(selectedProducts).each((index, item) => {
        const product = $(item).val();
        const imageSource = $(item).data("img")
        const shorTitle = $(item).data("title")
        const shortDescription = $(item).data("description")
        const ingredientsList = $(item).data("ingredients")

        array.push({ id: product, quantity: 1, properties: properties, imageSrc: imageSource, title: shorTitle, ingredients: ingredientsList, description: shortDescription });
      });
    }

    this.populateSingleItemsQtyTracker(array)
    // this.populateFlavorsIngredientsModalContent(array)

    window.items = array;
  }

  resetSingleItemSelection() {
    this.$singleItem.each((index, item) => {
      const input = $(item).find("input[type=number]");
      const text = $(item).find(".quantity");

      $(input).val(0);
      $(text).text(0);
      $(item).removeClass("selected");
    });
  }

  __handleAddToBundle(e) {
    const target = e.currentTarget;
    const parent = $(target).closest(this.selectors.singleItem);
    const quantity = $(parent).find(".quantity");
    const input = $(parent).find("input[type=number]");

    if(this.$totalQuantity >= this.$selectedQuantity) return;

    $(quantity).text(1);
    $(input).val(1);

    $(parent).addClass("selected");

    this.changeBundleState();
  }

  addToCart() {
    this.getBundleItems();

    // fetch('/cart/add.js', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     items: window.items
    //   })
    // })
    // .then(response => response.json())
    // .then(data => {
    //   console.log('Items added to cart:', data);
    //   // Optional: Trigger UpCart to open or refresh
    //   if (window.UpCart) {
    //     window.UpCart.open(); // or UpCart.refreshCart();
    //   }
    // })
    // .catch(error => {
    //   console.error('Error adding items to cart:', error);
    // });

    CartJS.addItems(window.items, function(cart) {
      // Callback function (e.g., update the UI)
      console.log("Cart updated:", cart);
    });
  }

  setCountDown() {
    if(this.$timer.length == 0) return;

    const date = this.$timer.data("date").split("/");
    const time = this.$timer.data("time").split(":");

    const hours = time[0];
    const mins = time[1];
    const month = parseInt(date[0]) - 1;
    const day = date[1];
    const year = date[2];
    let timerInterval;

    const targetDatePacific = new Date(Date.UTC(year, month, day, hours, mins));

    function padZero(num) {
      return num < 10 ? '0' + num : num;
    }

    function updateCountdown() {
      const now = new Date();

      // Get current UTC time
      const nowUtc = new Date(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        now.getUTCSeconds()
      );

      const diff = targetDatePacific - nowUtc;

      if (diff <= 0) {
        clearInterval(timerInterval);
        return;
      }

      const days = padZero(Math.floor(diff / (1000 * 60 * 60 * 24)));
      const hours = padZero(Math.floor((diff / (1000 * 60 * 60)) % 24));
      const minutes = padZero(Math.floor((diff / (1000 * 60)) % 60));
      const seconds = padZero(Math.floor((diff / 1000) % 60));

      $(".timer .days").text(days);
      $(".timer .hours").text(hours);
      $(".timer .mins").text(minutes);
      $(".timer .seconds").text(seconds);
    }

    // Update countdown immediately and then every second
    updateCountdown();
    timerInterval = setInterval(updateCountdown, 1000);
  }

  toggleDescription(e) {
    const target = e.currentTarget;
    const container = this.$element.find(".product-top__description");
    container.toggleClass('truncated');
    const isTruncated = container.hasClass('truncated');
    $(target).text(isTruncated ? 'Read more' : 'Show less');
  }
}